import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ModifyTaskCreationConfigsMutationVariables = Types.Exact<{
  data: Types.ModifyTaskCreationConfigsInput;
}>;


export type ModifyTaskCreationConfigsMutation = { modifyTaskCreationConfigs?: { okr?: { id: string } | { id: string } | null, file?: { id: string } | null } | null };


export const ModifyTaskCreationConfigsDocument = /*#__PURE__*/ gql`
    mutation modifyTaskCreationConfigs($data: ModifyTaskCreationConfigsInput!) {
  modifyTaskCreationConfigs(data: $data) {
    okr {
      ... on KeyResultType {
        id
      }
      ... on ObjectiveType {
        id
      }
    }
    file {
      id
    }
  }
}
    `;

export function useModifyTaskCreationConfigsMutation() {
  return Urql.useMutation<ModifyTaskCreationConfigsMutation, ModifyTaskCreationConfigsMutationVariables>(ModifyTaskCreationConfigsDocument);
};